import CronoEditor from './CronoEditor';
import { ICronoEditorProps } from './CronoEditor';
import { cn } from 'utils/style-utils';
import './styles.css';
import React, { useEffect, useState } from 'react';

interface IProps extends Omit<ICronoEditorProps, 'children'> {
  onSave: (value: string) => void;
  // Fires only for edits made by the user, never for programmatic value
  // updates or Quill's own HTML normalization
  onUserValueChange?: (value: string) => void;
  minRows?: number;
  maxRows?: number;
  label?: string;
  containerClassName?: string;
  containerStyle?: React.CSSProperties;
  children?: (props: { value: string }) => React.ReactElement;
}

export const CronoEditorRichField = React.forwardRef<HTMLDivElement, IProps>(
  (
    {
      minRows,
      maxRows,
      editorRef,
      defaultValue,
      children,
      containerClassName,
      containerStyle,
      onUserValueChange,
      ...props
    },
    ref,
  ) => {
    const [value, setValue] = useState((defaultValue as string) ?? '');

    useEffect(() => {
      setValue((defaultValue as string) ?? '');
    }, [defaultValue]);

    return (
      <div
        ref={ref}
        className={cn(
          'flex flex-col gap-1 border border-neutral-300 rounded-lg p-[5px] pr-0 crono-editor-rich-field-container',
          containerClassName,
        )}
        style={{
          maxHeight: maxRows ? `${maxRows * 20}px` : undefined,
          minHeight: minRows ? `${minRows * 20}px` : undefined,
          ...containerStyle,
        }}
      >
        <CronoEditor
          {...props}
          value={value}
          onChange={(text, _delta, source) => {
            setValue(text);
            if (source === 'user') {
              onUserValueChange?.(text);
            }
          }}
          className={cn(props.className, 'crono-editor-rich-field')}
          hideStylingButtons
          hideToolbar
          editorRef={editorRef}
        />

        {children && children({ value })}
      </div>
    );
  },
);
